import React, { useState, useEffect } from "react";
import CourseService from "../../../Api/CourseService";
import AddonPacksService from "../../../Api/AddonPacksService";

const OrderHistory = () => {
    const [purchases, setPurchases] = useState([]);
    const [addonPacks, setAddonPacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('courses');
    const courseService = new CourseService();
    const addonPacksService = new AddonPacksService();

    useEffect(() => {
        fetchPurchaseHistory();
        fetchAddonPacksHistory();
    }, []);

    const fetchPurchaseHistory = async () => {
        try {
            const response = await courseService.GetPurchaseCourse();
            if (response.data.status === "success") {
                setPurchases(response.data.data);
            } else {
                setError("Failed to load purchase history");
            }
        } catch (err) {
            setError("Error loading purchase history");
            console.error("Error fetching purchase history:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchAddonPacksHistory = async () => {
        try {
            const response = await addonPacksService.GetpurchasedAddonPacks();
            if (response.data.status === "success") {
                setAddonPacks(response.data.data);
            }
        } catch (err) {
            console.error("Error fetching addon packs history:", err);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const getStatusBadge = (isExpired) => {
        if (isExpired) {
            return (
                <span className="rbt-badge-5 bg-color-danger-opacity color-danger">
                    Expired
                </span>
            );
        }
        return (
            <span className="rbt-badge-5 bg-color-success-opacity color-success">
                Active
            </span>
        );
    };

    if (loading) {
        return (
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3">Order History</h4>
                </div>
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3">Order History</h4>
                </div>
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="content">
            <div className="section-title">
                <h4 className="rbt-title-style-3">Order History</h4>
            </div>
            
            <div className="rbt-tabs-wrapper">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button 
                            className={`nav-link ${activeTab === 'courses' ? 'active' : ''}`}
                            id="courses-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#courses"
                            type="button"
                            role="tab"
                            aria-controls="courses"
                            aria-selected={activeTab === 'courses'}
                            onClick={() => setActiveTab('courses')}
                        >
                            Course Purchases
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button 
                            className={`nav-link ${activeTab === 'addons' ? 'active' : ''}`}
                            id="addons-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#addons"
                            type="button"
                            role="tab"
                            aria-controls="addons"
                            aria-selected={activeTab === 'addons'}
                            onClick={() => setActiveTab('addons')}
                        >
                            Addon Packs
                        </button>
                    </li>
                </ul>
            </div>

            <div className="tab-content" id="myTabContent">
                <div className={`tab-pane fade ${activeTab === 'courses' ? 'show active' : ''}`} id="courses" role="tabpanel" aria-labelledby="courses-tab">
                    <div className="rbt-dashboard-table table-responsive mobile-table-750">
                        <table className="rbt-table table table-borderless">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Course Name</th>
                                    <th>Purchase Date</th>
                                    <th>Valid Until</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchases.map((purchase) => (
                                    <tr key={purchase.purchase_id}>
                                        <th>#{purchase.purchase_id}</th>
                                        <td>{purchase.course.title}</td>
                                        <td>{formatDate(purchase.purchased_at)}</td>
                                        <td>{formatDate(purchase.valid_until)}</td>
                                        <td>₹{purchase.amount_paid}</td>
                                        <td>
                                            {getStatusBadge(purchase.is_expired)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={`tab-pane fade ${activeTab === 'addons' ? 'show active' : ''}`} id="addons" role="tabpanel" aria-labelledby="addons-tab">
                    <div className="rbt-dashboard-table table-responsive mobile-table-750">
                        <table className="rbt-table table table-borderless">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Type</th>
                                    <th>Points Added</th>
                                    <th>Purchase Date</th>
                                    <th>Amount</th>
                                    <th>Payment ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {addonPacks.map((pack) => (
                                    <tr key={pack.id}>
                                        <th>#{pack.id}</th>
                                        <td>{pack.type}</td>
                                        <td>{pack.points_added}</td>
                                        <td>{formatDate(pack.purchased_at)}</td>
                                        <td>₹{pack.amount_paid}</td>
                                        <td>{pack.payment_id}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderHistory;
